export default "__VITE_ASSET__EO7HHmIa__"